import { navigate } from 'gatsby';
import { LINKS } from '../data/pageLinks.data';

export function navigateTo(e,link) {
    e.preventDefault();
    navigate(LINKS[link] || link);
};